import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './TopBar.css';

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleAnchor = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className={`topbar ${scrolled ? 'topbar--scrolled' : ''}`}>
      <Link to="/" className="topbar__mark display" aria-label="Bella 7 home">
        Bella<sup>7</sup>
      </Link>

      <nav className="topbar__nav" aria-label="Primary">
        <a href="#book" onClick={(e) => handleAnchor(e, 'book')}>Book</a>
        <a href="#contact" onClick={(e) => handleAnchor(e, 'contact')}>Contact</a>
      </nav>
    </header>
  );
}